import React, { useCallback, useEffect, useState } from 'react';
// import s from './s.module.less';
import { Input, Modal, message } from 'antd';
import GlobalLayerStore from 'store/GlobalLayer';
import { EType } from 'types/helloKlarity';
import { IBPMappingItem } from 'types/operation';
import { updateHelloKlarityAirtableTitle } from 'api/operation';

interface IProps {
    row?: IBPMappingItem | null;
    type: EType;
    onOk: (value: string) => void;
    onCancel: () => void;
}

const TitleUpdateModal = ({
    row,
    onOk,
    onCancel,
}: IProps) => {
    const [getGlobalLayer] = GlobalLayerStore.useStore();
    const [value, setValue] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (row) {
            setValue(row.airtableProviderTitle || '');
        }
    }, [row]);

    const update = useCallback(async (rowId: number, titleValue: string) => {
        if (rowId && titleValue) {
            setLoading(true);
            try {
                const res = await updateHelloKlarityAirtableTitle({
                    id: rowId,
                    airtableProviderTitle: titleValue,
                });

                if (res && !res.error) {
                    onOk(titleValue);
                } else {
                    message.error(res?.error);
                }
            } catch (e) {
                console.error(e);
            }

            setLoading(false);
        }
    }, [onOk]);

    const handleOk = useCallback(() => {
        if (row) {
            update(row.id, value);
        }
    }, [row, update, value]);

    const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
    }, []);
    return (
        <Modal
            title="Update title"
            width={312}
            open={getGlobalLayer('showProviderMappingUpdateTitleModal')}
            okText="Save"
            onOk={handleOk}
            onCancel={onCancel}
            confirmLoading={loading}
        >
            <Input onChange={onChange} value={value} />
        </Modal>
    );
};

export default TitleUpdateModal;
